<nav
  class="header main-header navbar navbar-expand navbar-white navbar-light pl-5 pr-5"
>
  <ul class="navbar-nav">
    <li class="nav-item">
      <a
        [class.sidebar-expanded]="!sidebarExpanded"
        class="nav-link"
        href="javascript:;"
        (click)="toggleSidebar()"
      >
        <div class="menu-icon">
          <img
            *ngIf="!sidebarExpanded"
            src="../../../../assets/img/hambergerMenu.svg"
            alt="Menu Closed"
          />
          <img
            *ngIf="sidebarExpanded"
            src="../../../../assets/img/menu-arrow.svg"
            alt="Menu Opened"
          />
        </div>
        <span class="menu-text"></span>
      </a>
    </li>
    <li class="ml-1">
      <app-breadcrumb class="breadcrumb"></app-breadcrumb>
    </li>
  </ul>
  <div class="img-logo" >
    <a class="brand-link h1 text-end" [routerLink]="['home']">
      <img
        src="assets/media/svg/illustrations/Logo_central_Azul.svg"
        alt="Logo"
        style="width: 73%; height: auto"
    /></a>
  </div>
</nav>
